import swal from 'sweetalert2';

export default class CartBlock extends HTMLDivElement {
    constructor() {
        super();
    }

    updateCartIndexView( data ) {
        this.updateCartViews( data );

        swal.close();
    }

    updateCartViews( data ) {
        if (data.hasOwnProperty('templates')) {
            $.each(data.templates, (templateName, templateHtml) => {
                let elementItem = $('[data-cart-template="' + templateName + '"]', 'body');

                if (elementItem.length) {
                    elementItem.children().remove();
                    elementItem.append(templateHtml);

                    if ($('.undeliverableAddress').length) {
                        swal({
                            type: 'error',
                            title: '',
                            html: true,
                            text: $('.undeliverableAddress').html()
                        });
                    }
                } else if (templateName == 'cart-popup') {
                    toastr.success(templateHtml);
                } else if (templateName == 'cart-popup-html') {
                    $('[data-append-template="' + templateName + '"]')
                        .empty()
                        .append(templateHtml);
                }
            });
        }
    }

    askToDelete( deleteText, buttonText, callback ) {
        swal({
            title: '',
            html: "<span style='color: #F17474;'>ATTENTION ! <br />" + deleteText + "</span>",
            allowOutsideClick: true,
            type: 'warning',
            showCancelButton: true,
            closeOnConfirm: false,
            closeOnCancel: true,
            confirmButtonColor: '#ee0000',
            cancelButtonText: 'Annuler',
            confirmButtonText: buttonText,
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function ( resolve ) {
                    if ( callback ) {
                        callback( resolve );
                    }
                });
            }
        }).then(function () {
            swal.close();
        });
    }
};

